<template>
  <page-template >
    <template slot="page-content">
      <div class="cabanas--template page-template">
        <!-- PAGE BG -->
        <div class="db fixed top-0 bottom-0 w-100 vh-100 bg-cream z-2"></div>
        <div v-if="page.background_color" class="db fixed top-0 bottom-0 w-100 vh-100 z-2" :style="{opacity: (1.1 - bgOpaciy), 'background-color': page.background_color }"></div>
        <div v-else class="db fixed top-0 bottom-0 w-100 vh-100 bg-blue z-2" :style="{opacity: (1.1 - bgOpaciy), 'background-color': page.background_color }"></div>

        <div class="relative container-fluid mw9 center z-3 pt4 pb3">
          <h1 class="headingIcon is-cream f40px is-lorano-bold relative dib">{{ page.heading_title }}<img class="absolute" alt="Info":src="page.hero_image"/></h1>
        </div>

        <div class="relative z-content">
          <img class="absolute" :style="calcParallax('tasteBubble', 200, 800, 'right:-70px;')" src="/uploads/tastebubble.svg" ref="tasteBubble" />
          <img class="absolute" :style="calcParallax('leftBubble', 650, 120, 'left:-120px;')" src="/uploads/left-bubble.svg" ref="leftBubble" />
        </div>

        <div class="relative container-fluid-ns mw9 center z-content">
          <div class="row">
            <div class="col-sm-6 pb5">
              <img class="w-100" :src="page.cabanas_info.image" alt="Cabanas"/>
              <div class="container-fluid-sm">
                <h2 class="is-tablet-cond-bold f2 pv3">{{ page.cabanas_info.title }}</h2>
                <p class="f15px is-tablet-regular pb3 w-90 lh-copy" v-html="marked(page.cabanas_info.content_text)"></p>
                <h3 class="is-tablet-bold f20px pv3">{{ page.cabanas_info.amenities_info.title }}</h3>
                <ul v-for="(cabanas, index, key) in page.cabanas_info.amenities_info.amenities_list">
                  <li class="f15px is-tablet-regular">{{ cabanas }}</li>
                </ul>
              </div>
            </div>

            <div class="col-sm-6 pb5">
              <img class="w-100" :src="page.box_suites.image" alt="Cabanas"/>
              <div class="container-fluid-sm">
                <h2 class="is-tablet-cond-bold f2 pv3">{{ page.box_suites.title }}</h2>
                <div class="f15px is-tablet-regular pb3 w-90 lh-copy" v-html="marked(page.box_suites.content_text)"></div>
                <h3 class="is-tablet-bold f20px pv3">{{  page.box_suites.amenities_info.title }}</h3>
                <ul v-for="(box, index, key) in page.box_suites.amenities_info.amenities_list">
                  <li class="f15px is-tablet-regular">{{ box }}</li>
                </ul>
              </div>
            </div>

          </div>
        </div>

        <div class="w-100 pb5 flex flex-column ">
          <div class="bg-blue-after pv5 relative">
            <div class="flex flex-column container-fluid relative z-4">
              <h4 class="is-tablet-cond-bold f20px is-white center tc lh-copy pv4 dib mw6-5">{{ page.contact_us.title }}</h4>
              <a class="btn-secondary has-cream-bg center mb4 mb0-m mb0-l" :title="page.contact_us.link_title" :href="page.contact_us.link">
                <span class="text ttu">
                  {{ page.contact_us.link_text }}
                </span>
              </a>
            </div>
          </div>
        </div>

        <div class="relative z-3">
          <img class="absolute" :style="calcParallax('smallBubble', -250, 350, 'right:4vw;')" src="/uploads/small-bubble-optim.png" ref="smallBubble" />
          <img class="absolute" :style="{'top':parallax + 'px', 'display': 'none'}" src="" />
        </div>

      </div>
    </template>
  </page-template>
</template>

<script>
import PageTemplate from './page-template.vue';
import SignupForm from './signup-form.vue';
export default {
  components: {
    PageTemplate,
    SignupForm,
  },
  props: ['id','pageMarkdownFileName'],
  metaInfo () {
    return {
      title: this.page.seo_title,
      titleTemplate: (titleChunk) => {
        return titleChunk ? `${titleChunk} | ` + this.$site_seo_title_suffix : this.$site_seo_title_suffix;
      },
      meta: [
        { vmid: 'description', name: 'description', content: this.page.seo_description }
      ]
    }
  },
  data () {
    return {
      bgOpaciy: 0,
      bgScrollStart: 10,
      scrollPos: 0,
      parallax:null,
      parallax2:true,
      window: {
        width: 0,
        height: 0
      },
      isWindowWidthMobile: null,
    }
  },
  computed: {
    page: function () {
      var pageData = this.$store.getters.filterPagesByName('cabanas.markdown');
      return pageData[0];
    },
  },
  methods : {
    scrollBg: function() {
      // console.log('scrollBg', window.scrollY, this.bgOpaciy);
        if ((document.body.getBoundingClientRect()).top > this.scrollPos) {
          // console.log('document, this.bgOpacity: ', this.bgOpaciy);
          //this.bgOpaciy = 0 + (1 - window.scrollY * 0.001);
          if (window.scrollY > this.bgScrollStart) {
            this.bgOpaciy = (window.scrollY * 0.001);
            // console.log('SCROLL UP: ', window.scrollY, this.bgOpaciy);
          }
          else {
            this.bgOpacity = 0;
            // console.log('else', window.scrollY, this.bgOpacity);
          }
        }
        else {
          //this.bgOpaciy = this.bgOpaciy - (window.scrollY * (0.0001));
          this.bgOpaciy = (window.scrollY * 0.001);
          // console.log('SCROLL DOWN: ', window.scrollY, this.bgOpaciy);
        }
        // saves the new position for iteration.
        this.scrollPos = (document.body.getBoundingClientRect()).top;
    },
    sizing: function(){
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width < 768)
        this.isWindowWidthMobile = true; 
      else{
        this.isWindowWidthMobile = false; 
        this.mobileActive = -1;
      }
      this.scrollBg();
    },
    calcParallax: function(myTarget, offset, movement, positioning){
      if(this.$refs[myTarget]){
        this.parallax2 = false;
        if((this.$refs[myTarget].parentElement.getBoundingClientRect().y + offset + this.$refs[myTarget].getBoundingClientRect().height) + movement > 0 && (this.$refs[myTarget].parentElement.getBoundingClientRect().y + offset) - movement  < window.innerHeight){
          var newMovement = offset + (((this.$refs[myTarget].parentElement.getBoundingClientRect().y + offset + (this.$refs[myTarget].getBoundingClientRect().height / 2) - (window.innerHeight / 2) - 27) / window.innerHeight) * movement);
          return 'top:'+newMovement+'px;'+positioning;
        } else {
          return 'display:none;';
        }
      }
    },
  },
  created() {
    var w = window.innerWidth;
    if (w < 768) {
      this.isWindowWidthMobile = true; 
    }
    else {
      this.isWindowWidthMobile = false; 
    }
    //
  },
  beforeMount() {
    //
  },
  mounted() {
    setInterval(() => {
      if(this.parallax2 !== false)
        this.parallax = this.parallax + 0.02;
    }), 10;
    this.$nextTick(() => {
      //
    })

  },
  beforeDestroy() {
    //
  },
  destroyed() {
    //
  }
}
</script>
